import React from 'react';
import { connect } from 'react-redux';

import Input from '@components/Input';

import { setPanelDPP } from '@reducers/options/panel/actions';
import Application from '../../../Application';
import { unitLabel, unitTransform } from '@services/helper.service';
import { defaultUnits } from '@config';

const Dpp = props => {
  if (props.type === Application.types.SAFETY_BARRIER && props.isDpp) {
    return (
      <Input
        prefix="Dpp ="
        postfix={unitLabel(props.unit)}
        id="dpp"
        type="number"
        minValue={0}
        className="base-plate__input_block"
        value={props.dppValue}
        onUpdate={value => {
          props.setDppValue(value, props.unit);
        }}
      />
    );
  }

  return null;
};

const mapState = state => {
  const unit = state.main.units.distance;

  if (state.options.panel.dpp) {
    return {
      isDpp: state.options.panel.dpp.active,
      dppValue: unitTransform(state.options.panel.dpp.value).from(defaultUnits.DISTANCE).to(unit),
      unit,
      type: state.main.appType,
    };
  }
  else 
    return {}; // mapStateToProps() in Connect(Dpp) must return a plain object. Instead received undefined.
};

const mapDispatch = dispatch => ({
  setDppValue: (value, unit) => 
    dispatch(setPanelDPP({
        value: unitTransform(parseFloat(value), false).from(unit).to(defaultUnits.DISTANCE)
    })),
});

export default connect(mapState, mapDispatch)(Dpp);



// WEBPACK FOOTER //
// ./src/views/Dimension/components/BasePlate/Dpp.js